//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver } from 'vee-validate'
import { FormInput } from '@/components/Form'
import ROLES from '@/constants/roles'
import Button from '~/components/Shared/Button'

export default {
  name: 'InvitationModal',
  components: {
    FormInput,
    ValidationObserver,
    Button,
  },
  props: {
    onSuccess: {
      default: () => {},
      type: Function,
    },
    roleType: {
      type: String,
      default: ROLES.EMPLOYEE,
    },
    projectId: {
      type: Number,
      required: true,
    },
    sendInvitation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ROLES,
      options: {
        languages: [],
        locations: [],
      },
      validated: false,
      form: {
        user: {
          names: '',
          lastnames: '',
          email: '',
          repeatEmail: '',
        },
        message: null,
      },
      observerKey: 0,
    }
  },
  computed: {
    formSubmit() {
      const form = {
        ...this.form.user,
      }
      delete form.repeatEmail
      if (form.email) {
        return form
      }
      delete form.email
      return form
    },
  },

  watch: {
    form: {
      handler(val) {
        this.validateAndEmitInvalid()
      },
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = {
        user: {
          names: '',
          lastnames: '',
          email: '',
          repeatEmail: '',
        },
        message: null,
      }
      this.validated = false
      this.$refs.observer.reset()
      this.observerKey += 1
    },
    importMassiveUsers() {
      this.$emit('import-massive-users')
    },
    async submit() {
      if (this.form.user.email === '' && this.form.user.repeatEmail === '') {
        this.$emit('user-without-email-confirmation')
      } else {
        const response = await this.saveUser()
        return response
      }
    },
    async saveUser() {
      this.$store.commit('loading', true)
      try {
        const user = this.formSubmit
        user.project_id = this.projectId

        await this.$repository.invitation.newSingleCreateCollaborators({
          user,
          sendInvitation: this.sendInvitation,
        })
        this.onSuccess()
        this.$buefy.notification.open({
          message: `<p style="margin-top: 10px">El usuario se añadió al proyecto correctamente.</p>`,
          type: 'is-success',
          hasIcon: true,
          duration: 5000,
        })
        return true
      } catch (e) {
        this.$buefy.notification.open({
          message: 'No se pudo añadir el usuario al proyecto.',
          type: 'is-danger',
          duration: 5000,
        })
        this.$emit('user-with-error', e.message)
        return false
      } finally {
        this.$store.commit('loading', false)
      }
    },
    async validateAndEmitInvalid() {
      if (
        (this.form.user.names !== '' && this.form.user.lastnames !== '') ||
        this.validated
      ) {
        const isValid = await this.$refs.observer.validate()
        this.validated = true
        this.$emit('validation-invalid', !isValid)
      }
    },
  },
}
